import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ReportService } from "./services/report.service";
import { Subject, Subscription, EMPTY } from "rxjs";
import { LanguageService } from './services/language.service';
import { takeUntil, switchMap } from 'rxjs/operators';
import { Language } from './models/language';
import { StudentStatisticsService } from 'src/app/services/student-statistics.service';
import { TranslateService } from '@ngx-translate/core';
import { DocumentData } from './services/document-data.service';
import { Store } from '@ngrx/store';
import { getCurrentUser } from 'src/app/authModule/state/authentication.selectors';
import * as authActions from 'src/app/authModule/state/actions/authentication.actions';
import { User } from './models/user';
// import {SpinnerService} from "../../services/spinner.service";
// import { DocumentComponent } from '../panel-components/document/document.component';
import { HttpClient } from '@angular/common/http';
import { UserService } from 'src/app/services/user.service';
import { Title } from '@angular/platform-browser';
import { StylometricStateService } from './services/stylometric-state.service';
import { filter } from 'rxjs/operators';
import { SessionService } from '../../services/session.service';
import { AssignmentService } from 'src/app/services/assignment.service';

@Component({
  selector: 'app-report-v2',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
})
export class ReportComponent implements OnInit {
  summaryDetails: any[] = [];
  submissionDetails: any;
  isOnAnalysis: boolean = false;
  isOnAi = false;
  isOnManipulation: boolean = false;
  sources: {
    sources?: any[] | undefined,
    excludedSources?: any[] | undefined
  } = {
      sources: [],
      excludedSources: []
    };

  initialSources: {
    originalSources: [],
    excludedOriginalSources: [],
    translatedSources: [],
    excludedSourcesMlPlag: {
      language: string,
      sources: []
    }[],
    topOriginalSources: any[],
    topTranslatedSources: any[]
  } =
    { originalSources: [], excludedOriginalSources: [], translatedSources: [], excludedSourcesMlPlag: [], topOriginalSources: [], topTranslatedSources: [] }

  navigationDetails: any
  fileUrl: any
  similarityAnalysis: any;
  bannerDetails: {
    title: string,
    original_language: string,
    translated_language: string,
    ai_authorship_analysis: boolean,
    file_size: string,
    word_count: string,
    page_count: string,
    documentId: string
  } = {
      title: '',
      original_language: '',
      translated_language: '',
      ai_authorship_analysis: false,
      file_size: '',
      word_count: '',
      page_count: '',
      documentId: ''
    };
  aiAnalysis: { aiPercentage: number, checkAI: boolean, originalSources: [] } = {
    aiPercentage: 0,
    checkAI: false,
    originalSources: []
  };
  docStatus: any;
  current_language: any;
  current_language_type: any;
  selectedSourcesFilter = 0
  selectedDocumentLanguage: { language: string, type: string } = { language: '', type: 'Original' }
  filteredSources: any
  isOriginalLanguage = true;
  initialNavigationData: any
  selectedSourcesToHighlight: number[] = []
  currentPageSubscription: Subscription[] = []
  analysisType = 'analysis';
  sentencesWithAI!: [];
  submissionAISentences: any[] = []
  navigationArrayAI: any[] = []
  selectedManipulation: string = '';
  pdfImagesSrc = '';
  tempPdfSrc = '';
  sentenceDetails!: any[];
  imagesDetectionData: any;
  allManipulations: any;
  submissionId: any;
  studentDeletionPermissions: any;
  isDocumentInArchive: any;
  sourcesAreDeleted: any;
  sentenceInformation = false
  submission: any;
  quotesToggle: any;
  selectedTranslatedLanguage: any;
  languages: Language[] = [];
  private destroy$ = new Subject<void>();
  isOnCohort: boolean = false
  cohortValues: any[];
  submissionValues: any[];
  exactMatchThreshold: any;
  currentLanguage: string = localStorage.getItem('websiteLanguage');
  contextSimilarity: any;
  hasTranslatedLanguages: boolean;
  canEdit: boolean = true;
  currentUser$: any;
  currentUserDetailsSubscriber$: any;
  translationSources: any;
  isOnIA: boolean;
  metadata: any;
  metadataUrl: string = '';
  author: any;
  reportType: 'classic' | 'stylometric' = 'classic';
  stylometricMetrics: any;
  previousSubmissions: any[] = [];
  formattedPreviousSubmissions: any = null;
  metricsThresholds: any;
  averageStylisticDiscrepancy: string = '';
  stylometricsEnable: boolean = false;
  projectSynapseEnable: boolean = false;
  metadataEnable: boolean = false;
  simpleAIEnable: boolean = false;
  projectSynapse: [] = [];
  sideBarCollapsed: boolean = false;
  analysisDate: any;
  currentModel: string = '';
  originalityDisplay: string = '';
  isNotStudentPrecheck: boolean = false;
  canBeCohort: boolean = false;

  constructor(
    private route: ActivatedRoute, private reportService: ReportService, private cdr: ChangeDetectorRef, private languageService: LanguageService,
    private studentStatisticsService: StudentStatisticsService, private translate: TranslateService, private documentDataService: DocumentData, private store: Store,
    private http: HttpClient, private userService: UserService,
    private titleService: Title, private stylometricState: StylometricStateService,
    private sessionService: SessionService,
    private assignmentService: AssignmentService
  ) {
  }

  ngOnInit(): void {
    // Check if the edit=true parameter is present
    const editParameter = this.route.snapshot.queryParams['edit'];
    if (editParameter) {
      localStorage.setItem('edit', 'true');
    }
    const editFromLocalStorage = localStorage.getItem('edit');
    const user = JSON.parse(localStorage.getItem('user'));

    this.originalityDisplay = user?.Institution?.InstitutionSettings?.[0]?.originalityDisplay;
    // Get sharing context data
    const sharingContext = this.sessionService.getSharingContext();


    this.stylometricState.reportType$.subscribe(type => {
      this.reportType = type;
    });

    this.currentPageSubscription.push(this.route.params.subscribe(
      (data: any) => {
        if (data.clientName) {
          this.isOnIA = true;
        } else {
          this.isOnIA = false;
        }

        this.reportService.submissionDetails(data.id ? data.id : data.submissionId, data.id ? false : true).subscribe(
          (submissionDetails: any) => {
            // Check if this is a student submission (has assignmentId)
            const isStudentSubmission = !!submissionDetails.submission?.assignmentsId;

            // If it's a student submission and no sharing context with edit permission, force view mode
            // Otherwise use the URL parameter or sharing context
            // No additional permission checks needed here - we'll handle them in the user info sections

            // Filter and store previous submissions
            if (submissionDetails.previous_submissions) {
              this.previousSubmissions = submissionDetails.previous_submissions.filter(
                (sub: any) => sub.stylometricsData !== null && sub.stylometricsData !== undefined
              );

              // Only calculate average metrics if we have valid submissions
              if (this.previousSubmissions.length > 0) {
                this.formattedPreviousSubmissions = {
                  all: this.calculateAverageMetrics(this.previousSubmissions),
                  individual: this.previousSubmissions.map((sub: any) => ({
                    filename: sub.filename.split('/').pop(),
                    title: sub.title,
                    fileUrl: sub.fileUrl,
                    metrics: this.formatStylometricData(sub.stylometricsData),
                    discrepancy: sub.stylistic_discrepancy
                  }))
                };
              } else {
                this.formattedPreviousSubmissions = null;
              }
            }

            // Safely handle stylometric data in the current submission
            const { stylometricsData } = submissionDetails.submission || {};
            if (stylometricsData) {
              const metricsCategories = ['lexical', 'readability', 'structural', 'syntactic'] as const;
              this.stylometricMetrics = metricsCategories.reduce((acc, category) => ({
                ...acc,
                [category]: stylometricsData[category] ?
                  Object.entries(stylometricsData[category]).map(([name, value]) => ({
                    name,
                    value: Number(value)
                  })) : []
              }), {} as Record<typeof metricsCategories[number], Array<{ name: string; value: number; flagged: boolean }>>);
            } else {
              // Initialize with empty arrays if no data
              this.stylometricMetrics = {
                lexical: [],
                readability: [],
                structural: [],
                syntactic: []
              };
            }

            if (submissionDetails.feature_thresholds) {
              this.metricsThresholds = submissionDetails.feature_thresholds;
            }

            if (submissionDetails.stylistic_discrepancy) {
              this.averageStylisticDiscrepancy = submissionDetails.stylistic_discrepancy;
            }

            if (submissionDetails.aiModelComparisons) {
              this.projectSynapse = submissionDetails.aiModelComparisons;
            }

            this.analysisDate = submissionDetails.submission.createdAt;

            this.author = submissionDetails.submission.filename.split('/')[1];
            this.studentDeletionPermissions = submissionDetails.studentDeletionPermission;
            this.isDocumentInArchive = submissionDetails.isDocumentInArchive;
            this.sourcesAreDeleted = submissionDetails?.sourcesAreDeleted;
            this.submissionId = data.id ? data.id : data.submissionId;
            this.sentencesWithAI = submissionDetails?.sentencesWithAI;
            this.docStatus = submissionDetails?.submission?.documentOriginalityPercentage?.toString();
            this.submissionDetails = submissionDetails;
            this.metadataUrl =  null;
            if (this.metadataUrl) {
              this.getMetadata(this.metadataUrl);
            } else {
              this.metadata = null;
            }
            this.fileUrl = null;
            this.tempPdfSrc = this.submissionDetails.fileUrl;
            const userRole = JSON.parse(localStorage.getItem('role'));

            // Set isNotStudentPrecheck based on user role and assignment ID
            this.isNotStudentPrecheck = (userRole === 9 && submissionDetails.submission.assignmentsId !== null);
            console.log('This is not student precheck', this.isNotStudentPrecheck);



            this.fileUrl = this.submissionDetails.fileUrl;
            this.pdfImagesSrc = this.submissionDetails.fileUrl;
            this.submissionAISentences = submissionDetails.sentencesWithAI
            this.quotesToggle = submissionDetails.submission.quotesToggle
            this.reportService.toggleQuotesSubject.next(this.quotesToggle);
            this.exactMatchThreshold = this.submissionDetails.submission?.sentence_thresholds?.exactMatchThreshold || 80
            this.contextSimilarity = this.submissionDetails.submission?.sentence_thresholds?.contextualSimilaritiesThreshold || 80
            this.currentUser$ = submissionDetails.submission.user;
            if (!this.isOnIA) {
              this.userService.userInfo(submissionDetails.submission.userId, localStorage.getItem('ACCESS_TOKEN')).subscribe((data: any) => {
                localStorage.setItem('user', JSON.stringify(data.userFromToken ? data.userFromToken : data.user));
                localStorage.setItem('role', data.userFromToken ? data.userFromToken.roleId : data.user.roleId);

                if (data.userFromToken) {
                  // Get sharing context to determine edit permissions
                  const sharingContext = this.sessionService.getSharingContext();

                  if (sharingContext && sharingContext.isShared) {
                    // If it's a shared report, use the access permission from sharing context
                    this.canEdit = sharingContext.accessPermission === 'edit';
                  } else {
                    // If it's not a shared report, canEdit is true except for role 9 with assignmentId not null
                    this.canEdit = !(data.userFromToken?.roleId === 9 && submissionDetails.submission.assignmentsId !== null);
                  }

                  console.log(data.userFromToken, 'data.userFromToken');

                  const institutionSettings = data.userFromToken.Institution.InstitutionSettings[0];
                  // Check if stylometricsData is null or empty
                  const hasStylemetricsData = submissionDetails.submission?.stylometricsData !== null &&
                    submissionDetails.submission?.stylometricsData !== undefined;

                  // Check if aiModelComparisons is null or empty array
                  const hasProjectSynapseData = submissionDetails.aiModelComparisons &&
                    Array.isArray(submissionDetails.aiModelComparisons) &&
                    submissionDetails.aiModelComparisons.length > 0;

                  // Set flags based on both institution settings and data availability
                  this.stylometricsEnable = institutionSettings.stylometricsAnalysis ?
                    (submissionDetails.submission.stylometricsAnalysis ? hasStylemetricsData : false) :
                    false;
                  this.projectSynapseEnable = institutionSettings.aiDetectionAdvanced ? hasProjectSynapseData : false;
                  this.metadataEnable = submissionDetails.submission.metadataAnalysis || false;
                  this.simpleAIEnable = submissionDetails.submission.aiDetection || false;
                }

                // HERE
                // this.assignmentService.getAssignment(this.submissionDetails?.submission?.assignmentsId).subscribe((data) => {
                //   this.canBeCohort = data?.Submissions?.length > 1;
                // })
                // console.log(this.canBeCohort, 'canBeCohort');

                // if (this.submissionDetails?.submission?.assignmentsId && (userRole === 9 || userRole === 10 || userRole === 11)) {
                //   this.studentStatisticsService.studentAssignments(-1, '', '', this.submissionDetails?.submission?.assignmentsId, this.submissionId).subscribe((data) => {
                //     if (data.studentAssignments.length !== 0) {
                //       this.cohortValues = [
                //         data?.studentAssignments[0]?.averageMLPlag?._avg?.originalPercentage.toFixed(2),
                //         data?.studentAssignments[0]?.averageMLPlag?._avg?.translatedPercentage.toFixed(2),
                //         data?.studentAssignments[0]?.averageAIAuthorship ? data.studentAssignments[0]?.averageAIAuthorship.toFixed(2) : 0,
                //         data?.studentAssignments[0]?.averageManipulations.toFixed(2),
                //         data?.studentAssignments[0]?.averagewordCount?.toFixed(2),
                //       ]

                //       this.submissionValues = [
                //         this.submissionDetails.submission.originalPercentage,
                //         this.submissionDetails.submission.translatedLanguage ? this.submissionDetails.submission.translatedPercentage.toFixed(2) : 0,
                //         this.submissionDetails.submission.aiDetection ? this.submissionDetails.submission.aiPercentage.toFixed(2) : 0,
                //         this.submissionDetails.submission.characterReplacements + this.submissionDetails.submission.hiddenText + this.submissionDetails.submission.imageAsText,
                //         this.submissionDetails.submission.wordCount,
                //       ]
                //     } else {
                //       this.cohortValues = [
                //         0, 0, 0, 0, 0
                //       ]
                //       this.submissionValues = [
                //         0, 0, 0, 0, 0
                //       ]
                //     }
                //   })
                // }
              });
            } else {
              let userFromToken = this.submissionDetails.submission.user;
              console.log(userFromToken, 'IA userFromToken');

              if (userFromToken) {
                // Get sharing context to determine edit permissions
                const sharingContext = this.sessionService.getSharingContext();

                if (sharingContext && sharingContext.isShared) {
                  // If it's a shared report, use the access permission from sharing context
                  this.canEdit = sharingContext.accessPermission === 'edit';
                } else {
                  // If it's not a shared report, canEdit is true except for role 9 with no assignment
                  this.canEdit = !(userFromToken?.roleId === 9 && submissionDetails.submission.assignmentsId === null);
                }

                const institutionSettings = userFromToken.Institution.InstitutionSettings[0];
                // Check if stylometricsData is null or empty
                const hasStylemetricsData = submissionDetails.submission?.stylometricsData !== null &&
                  submissionDetails.submission?.stylometricsData !== undefined;

                // Check if aiModelComparisons is null or empty array
                const hasProjectSynapseData = submissionDetails.aiModelComparisons &&
                  Array.isArray(submissionDetails.aiModelComparisons) &&
                  submissionDetails.aiModelComparisons.length > 0;

                // Set flags based on both institution settings and data availability
                this.stylometricsEnable = institutionSettings.stylometricsAnalysis ?
                  (submissionDetails.submission.stylometricsAnalysis ? hasStylemetricsData : false) :
                  false;
                this.projectSynapseEnable = institutionSettings.aiDetectionAdvanced ? hasProjectSynapseData : false;
                this.metadataEnable = submissionDetails.submission.metadataAnalysis || false;
                this.simpleAIEnable = submissionDetails.submission.aiDetection || false;
                console.log('simpleAIEnable on IA', this.simpleAIEnable);

              }

            }

            this.submissionAISentences?.forEach((sentence: any) => {
              if (sentence.aiText) {
                const existingPageIndex = this.navigationArrayAI.findIndex(item => item.page === sentence.page);
                if (existingPageIndex !== -1) {
                  // Increment numberOfSentences for the existing page
                  this.navigationArrayAI[existingPageIndex].numberOfSentences++;
                } else {
                  // If the page doesn't exist in the array, add it with numberOfSentences initialized to 1
                  this.navigationArrayAI.push({ page: sentence.page, numberOfSentences: 1 });
                }
              } else {
                const existingPageIndex = this.navigationArrayAI.findIndex(item => item.page === sentence.page);

                if (existingPageIndex === -1) {
                  // If the page doesn't exist in the array and aiText is false, add it with numberOfSentences initialized to 0
                  this.navigationArrayAI.push({ page: sentence.page, numberOfSentences: 0 });
                }
              }
            });
            this.getS3Json(submissionDetails.presignedUrlJson)

          },
          (err: any) => {
            console.log(err);
            this.metadata = null;
          }
        );
      },
      (err: any) => {
        console.log(err);
      }
    ),
      this.reportService.newS3JsonObject.subscribe((data: any) => {
        if (data) {
          this.getS3Json(data)
        }
      }),
      this.reportService.filterSourcesObject.subscribe((data: number) => {
        this.selectedSourcesFilter = data;
        this.filterSources(data)
      }),
      this.reportService.selectLanguageObject
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: { language: string, type: string }) => {
          this.current_language = data.language;
          this.current_language_type = data.type;
          this.isOriginalLanguage = data.type === 'Original';

          if (data.type === 'Original' && this.selectedDocumentLanguage.type !== 'Original') {
            this.sources = {
              sources: this.initialSources.originalSources,
              excludedSources: this.initialSources.excludedSourcesMlPlag
            }
            this.navigationDetails = this.initialNavigationData.originalNavigationArray;
            this.filterSources(0);
          }

          // Navigation is calculated independently and doesn't need to be updated on language change
          this.selectedDocumentLanguage = data;
        }),
      this.reportService.currentTranslatedLanguageObject
        .pipe(
          takeUntil(this.destroy$),
          // Filter out empty strings and handle initial state
          filter(lang => lang !== null && lang !== undefined)
        )
        .subscribe((lang: string) => {
          if (lang !== '') {
            this.selectedTranslatedLanguage = lang;
            // Only update sources and navigation if we're in translated mode
            if (this.selectedDocumentLanguage.type === 'Translated') {
              this.filterSources(0);
              this.navigationDetails = this.initialNavigationData.translatedNavigationArray[lang];
            }
          }
        }),
      this.reportService.selectedSourcesObject.subscribe((data: any) => {
        this.selectedSourcesToHighlight = data
        // Navigation is calculated independently and doesn't need to be updated on source selection
      })
    )

    this.reportService.sentenceInformationObject.subscribe(data => {
      this.sentenceInformation = data !== null;
      // if (data !== null && data?.translated && data?.translated.length > 0) {
      //   this.reportService.selectedTransltaionCodeSubject.next(data?.translated[0].lang)
      // }
    });

    this.reportService.selectAnalysisTypeObject.subscribe((data: string) => {
      this.analysisType = data;
    })

    this.reportService.selectManipulationTypeObject.subscribe((type: string) => {
      this.selectedManipulation = type;
    });

    this.languageService.getLanguages().subscribe((data: any) => {
      this.languages = data;
    });

    this.languageService.selectedLanguage$.subscribe((language: string) => {
      this.currentLanguage = language;
      this.translate.use(language);
    });

    this.reportService.filterSourcesObject.subscribe((param: number) => {
      this.filterSources(param);
    });

  }

  filterSources(type: number) {
    let sources;
    let excludedSources;
    let excludedInsideOriginalSources;
    let excludedInsideTranslatedSources;
    if (this.analysisType !== 'none') {
      if (!this.isOriginalLanguage) {
        if (this.initialSources.translatedSources.find((source: any) => source.language === this.selectedTranslatedLanguage)) {
          sources = this.initialSources.translatedSources.find((source: any) => source.language === this.selectedTranslatedLanguage)['sources'] as any;
        } else {
          sources = this.initialSources.translatedSources;
        }
        this.translationSources = sources;
      }

      if (!this.isOriginalLanguage) {
        // Get excluded sources for the selected translated language
        const excludedForLanguage = this.initialSources.excludedSourcesMlPlag.find(
          (item: any) => item.language === this.selectedTranslatedLanguage
        );
        excludedSources = excludedForLanguage?.sources || [];
      }

      if (this.isOriginalLanguage) {
        excludedInsideOriginalSources = this.initialSources.originalSources.filter((source: any) => source.isExcluded && source.hide);
      } else {
        if (this.initialSources.translatedSources.find((source: any) => source.language === this.selectedTranslatedLanguage)) {
          const tempArr = (this.initialSources.translatedSources.find((source: any) => {
            return source.language === this.selectedTranslatedLanguage
          }) as any)
          excludedInsideTranslatedSources = (tempArr['sources'] as any).filter((source: any) => source.hide && source.isExcluded)
        } else {
          const tempArr = this.initialSources.translatedSources;
          excludedInsideTranslatedSources = tempArr.filter((source: any) => source.hide && source.isExcluded)
        }
      }

      sources = this.isOriginalLanguage ? this.initialSources.originalSources : sources;
      excludedSources = this.isOriginalLanguage ? this.initialSources.excludedOriginalSources : excludedSources;

      if (type === 0) {
        this.filteredSources = sources.filter((source: any) => {
          return (source?.percentage > 1 && !source.isExcluded)
        });
        if (this.filteredSources.length === 0) {
          this.filteredSources = sources.filter((source: any) => (source?.percentage <= 1 && !source.isExcluded));
        }
      } else if (type === 1 || type === 2) {
        this.filteredSources = sources.filter((source: any) => source.type === type);
      } else if (type === 3) {
        let excludedSourcesInside = [];
        if (!this.isOriginalLanguage) {
          excludedSourcesInside = this.isOriginalLanguage ? excludedInsideOriginalSources : excludedInsideTranslatedSources;
        }
        this.filteredSources = [...excludedSources, ...excludedSourcesInside].filter((source: any) => source?.percentage !== undefined);
      } else if (type === 4) {
        this.filteredSources = sources.filter((source: any) => {
          const shouldInclude = (source?.percentage <= 1 || source?.percentage === 0) && !source.isExcluded;
          return shouldInclude;
        });
      }

      if (type === 0) {
        this.sources = { sources, excludedSources: this.sources.excludedSources };
      } else {
        this.sources = { sources: this.filteredSources, excludedSources: this.sources.excludedSources };
      }

      (this.similarityAnalysis ?? (this.similarityAnalysis = {}))[this.isOriginalLanguage ? 'originalSources' : 'translatedSources'] = this.filteredSources;
    } else {
      // For analysis type 'none', use the pre-calculated top sources
      if (type === 3) {
        // Handle excluded sources specifically
        if (this.isOriginalLanguage) {
          // For original language, use excludedOriginalSources
          this.filteredSources = this.initialSources.excludedOriginalSources || [];
        } else {
          // For translated language, find the excluded sources for the selected language
          const excludedForLanguage = this.initialSources.excludedSourcesMlPlag.find(
            (item: any) => item.language === this.selectedTranslatedLanguage
          );

          if (excludedForLanguage && excludedForLanguage.sources) {
            this.filteredSources = excludedForLanguage.sources;
          } else {
            // If no specific language match found, try to collect all excluded sources from all languages
            this.filteredSources = [];
            if (Array.isArray(this.initialSources.excludedSourcesMlPlag)) {
              this.initialSources.excludedSourcesMlPlag.forEach((langItem: any) => {
                if (langItem.sources && Array.isArray(langItem.sources)) {
                  // Add language code to each source for identification
                  const sourcesWithLang = langItem.sources.map((source: any) => ({
                    ...source,
                    languageCode: langItem.language
                  }));
                  this.filteredSources = [...this.filteredSources, ...sourcesWithLang];
                }
              });
            }
          }
        }
        sources = this.filteredSources;
      } else {
        // For other filter types
        if (this.isOriginalLanguage) {
          this.filteredSources = this.filterTopSources(this.initialSources.topOriginalSources, type);
        } else {
          this.filteredSources = this.filterTopSources(this.initialSources.topTranslatedSources, type);
        }
        sources = this.filteredSources;
      }

      this.sources = {
        sources: sources,
        excludedSources: this.isOriginalLanguage ?
          this.initialSources.excludedOriginalSources :
          this.initialSources.excludedSourcesMlPlag
      };
    }

    this.reportService.updateSources(this.sources)
    // Don't recalculate navigation here - navigation should be independent of filtering
    // Navigation dots should show for ALL active content regardless of current filter
  }

  /**
   * Filters top sources based on the filter parameter
   * @param sources The sources to filter
   * @param param The filter parameter (0: matching, 1: documents, 2: internet, 4: below 1%)
   * @returns Filtered sources
   */
  private filterTopSources(sources: any[], param: number): any[] {
    if (!sources || !Array.isArray(sources)) {
      return [];
    }

    switch (param) {
      case 0: // Matching sources
        const matchingSources = sources.filter(source => source.percentage > 1 && !source.isExcluded);
        return matchingSources.length > 0 ? matchingSources : sources.filter(source => source.percentage <= 1 && !source.isExcluded);
      case 1: // Sources from documents
      case 2: // Sources from internet
        return sources.filter(source => source.type === param && !source.isExcluded);
      case 4: // Sources below 1%
        const filteredSources = sources.filter(source => {
          const shouldInclude = (source.percentage <= 1 || source.percentage === 0) && !source.isExcluded;
          return shouldInclude;
        });
        return filteredSources;
      default:
        return sources;
    }
  }

  updateNavigationArray() {
    if (!this.navigationDetails) {
      return;
    }

    this.navigationDetails = [];

    // For both analysis and dashboard views, check both original and translated sources
    // This ensures dots remain visible if either language has active sources
    this.buildNavigationFromBothLanguages();

    this.processAdditionalNavigationData();
  }

  /**
   * Public method to recalculate navigation when sources are excluded/included
   * This ensures navigation dots reflect the current state of all sources
   */
  public recalculateNavigation() {
    if (this.navigationDetails) {
      this.updateNavigationArray();
    }
  }

  private buildNavigationFromSources(sources: any[]): void {
    if (!sources || !Array.isArray(sources)) {
      return;
    }

    sources.forEach((source: any, sourceIndex: number) => {
      if (source.sentences && Array.isArray(source.sentences)) {
        const shouldProcessSource = this.selectedSourcesToHighlight.length === 0 ||
          this.selectedSourcesToHighlight.includes(source.no);

        const isSourceExcluded = source.isExcluded || source.hide;

        if (shouldProcessSource && !isSourceExcluded) {
          source.sentences.forEach((sentence: any, sentenceIndex: number) => {
            if (sentence.page) {
              const isSentenceExcluded = sentence.isExcluded;

              if (!isSentenceExcluded) {
                const existingPage = this.navigationDetails.find((item: any) => item.page === sentence.page);
                if (existingPage) {
                  existingPage.numberOfSentences++;
                } else {
                  this.navigationDetails.push({
                    page: sentence.page,
                    numberOfSentences: 1
                  });
                }
              }
            }
          });
        }
      }
    });
  }

  /**
   * Builds navigation from both original and translated sources
   * This ensures dots remain visible if either language has active sources
   */
  private buildNavigationFromBothLanguages(): void {
    // Process original sources
    if (this.initialSources?.originalSources) {
      this.buildNavigationFromSources(this.initialSources.originalSources);
    }

    // Process translated sources
    if (this.initialSources?.translatedSources) {
      if (Array.isArray(this.initialSources.translatedSources)) {
        // Handle array of language objects
        this.initialSources.translatedSources.forEach((langSources: any, index: number) => {
          if (langSources.sources && Array.isArray(langSources.sources)) {
            this.buildNavigationFromSources(langSources.sources);
          } else if (Array.isArray(langSources)) {
            this.buildNavigationFromSources(langSources);
          }
        });
      }
    } else {
      // Handle direct array of sources
      this.buildNavigationFromSources(this.initialSources.translatedSources);
    }

  }

  processAdditionalNavigationData() {
    this.navigationArrayAI.forEach((page: any) => {
      this.incrementPageSentenceCount(page.page, page.numberOfSentences);
    });

    this.sentenceDetails.forEach((sentence: any) => {
      const replacedCharacters = sentence?.replacedCharacters || [];
      const includedReplacedCharacters = this.allManipulations?.replacedCharacters.filter((item: any) =>
        replacedCharacters.includes(item.character)
      );

      if (includedReplacedCharacters && includedReplacedCharacters.length > 0) {
        this.incrementPageSentenceCount(sentence.page, includedReplacedCharacters.length);
      }

      if (!sentence.whitecharactersExcluded) {
        this.incrementPageSentenceCount(sentence.page, sentence.characters.length);
      }
    });

    if (this.imagesDetectionData && this.imagesDetectionData.length > 0) {
      this.imagesDetectionData.forEach((image: any) => {
        if (image.label === 'red') {
          this.incrementPageSentenceCount(image.page + 1, 1);
        }
      });
    }
  }

  incrementPageSentenceCount(page: number, count: number) {
    const existingPage = this.navigationDetails.find((item: any) => item.page === page);
    if (existingPage) {
      existingPage.numberOfSentences += count;
    } else {
      this.navigationDetails.push({
        page: page,
        numberOfSentences: count
      });
    }
  }

  public getS3Json(presignedUrlJson: string) {
    // this.spinnerService.show()
    this.reportService.getS3Json(presignedUrlJson).subscribe(
      (data: any) => {
        // this.docStatus = data.originality
        this.submission = data.submission
        this.docStatus = this.submission?.documentOriginalityPercentage?.toString();

        let translatedLangs;
        if (this.submission) {
          if (this.submission?.translatedLanguage && this.submission?.translatedLanguage.split('').includes('[')) {
            translatedLangs = JSON.parse(this.submission?.translatedLanguage)
          } else {
            translatedLangs = [this.submission?.translatedLanguage]
          }
        }
        this.hasTranslatedLanguages = translatedLangs && translatedLangs?.length > 0;

        this.imagesDetectionData = data?.imagesDetection;
        this.sentenceDetails = data.sentenceDetails
        this.allManipulations = data.manipulations

        // Process excluded sources
        let excludedOriginalSources: any[] = [];
        let excludedTranslatedSources: any[] = [];

        // Handle excluded sources structure
        if (data.excludedSources) {
          excludedOriginalSources = data.excludedSources.original || [];

          // Handle translations structure which might be an array of language objects
          if (data.excludedSources.translations) {
            if (Array.isArray(data.excludedSources.translations)) {
              excludedTranslatedSources = data.excludedSources.translations;
            } else {
              // Convert object format to array format if needed
              excludedTranslatedSources = Object.keys(data.excludedSources.translations).map(langKey => ({
                language: langKey,
                sources: data.excludedSources.translations[langKey] || []
              }));
            }
          }
        }

        // Pre-calculate top sources for both original and translated content
        const topOriginalSources = this.getTopOriginalSources(data.originalSources);
        const topTranslatedSources = this.getTopTranslatedSources(data.translatedSources || []);

        this.initialSources = {
          originalSources: data.originalSources || [],
          excludedOriginalSources: excludedOriginalSources,
          translatedSources: data.translatedSources || [],
          excludedSourcesMlPlag: excludedTranslatedSources,
          topOriginalSources,
          topTranslatedSources
        } as any; // Use type assertion to avoid type errors

        // Log the structure for debugging


        // Add count of excluded translated sources
        const excludedTranslatedSourcesCount = this.initialSources.excludedSourcesMlPlag.reduce((total, langItem) => {
          return total + (langItem.sources ? langItem.sources.length : 0);
        }, 0);

        this.reportService.initialSourcesSubject.next(this.initialSources)
        this.initialNavigationData = {
          originalNavigationArray: data.originalNavigationArray,
          translatedNavigationArray: data.translatedNavigationArray
        }
        this.assignValues(data)
        // Calculate navigation after all data is loaded
        this.updateNavigationArray();
        this.filterSources(this.selectedSourcesFilter)
        // this.spinnerService.hide()
        this.transformData(data)
        this.reportService.documentPercentagesSubject.next({
          originalPercentage: data.submission.originalPercentage.toFixed(2), originalPercentageWithoutQuotes: data.submission.originalPercentageWithoutQuotes.toFixed(2),
          overallTransltedPercentage: data.submission.translatedPercentage.toFixed(2), overallTransltedPercentageWithoutQuotes: data.submission.translatedPercentageWithoutQuotes.toFixed(2)
        })
      },
      (err: any) => {
        console.log(err)
      })
  }

  /**
   * Gets the top original sources sorted by percentage
   * @param originalSources The array of original sources
   * @param topN The number of top sources to return (default: 5)
   * @returns Array of top original sources
   */
  private getTopOriginalSources(originalSources: any[], topN: number = 5): any[] {
    if (!originalSources || !Array.isArray(originalSources)) {
      return [];
    }

    const allSources = originalSources
      .filter(source => !source.hide)
      .sort((a, b) => b.percentage - a.percentage)
      .slice(0, topN);

    return allSources;
  }

  /**
   * Gets the top translated sources across all languages sorted by percentage
   * @param translatedSources The array of translated sources by language
   * @param topN The number of top sources to return (default: 5)
   * @returns Array of top translated sources with language information
   */
  private getTopTranslatedSources(translatedSources: any[], topN: number = 5): any[] {
    if (!translatedSources || !Array.isArray(translatedSources)) {
      return [];
    }

    // Flatten all sources from all languages and include the language code
    const allSources: any[] = [];

    translatedSources.forEach((lang: any) => {
      if (Array.isArray(lang)) {
        (lang as any).sources.forEach((source: any) => {
          allSources.push({
            ...source,
            languageCode: (lang as any).language
          });
        });
      } else if (lang.sources && Array.isArray(lang.sources)) {
        lang.sources.forEach((source: any) => {
          allSources.push({
            ...source,
            languageCode: lang.language
          });
        });
      } else {
        allSources.push(lang);
      }
    });

    // Sort sources by percentage and take the top N
    return allSources
      .sort((a, b) => b.percentage - a.percentage)
      .slice(0, topN);
  }

  assignValues(data: any) {
    let translatedNav = [];
    Object.keys(data.translatedNavigationArray).forEach((lang: any) => {
      if (Array.isArray(data.translatedNavigationArray[lang])) {
        data.translatedNavigationArray[lang].forEach((page: any) => {
          const existingPage = translatedNav.find((item: any) => item.page === page.page);

          if (existingPage) {
            existingPage.numberOfSentences += page.numberOfSentences;
          } else {
            translatedNav.push({
              page: page.page,
              numberOfSentences: page.numberOfSentences
            })
          }
        })
      } else {
        translatedNav = data.translatedNavigationArray;
      }
    })

    // Initialize navigation - will be calculated properly after all data is loaded
    this.navigationDetails = this.isOriginalLanguage ? data.originalNavigationArray : translatedNav
    this.sources = {
      sources: this.isOriginalLanguage ? data.originalSources : data.translatedSources,
      excludedSources: this.isOriginalLanguage ? data.excludedOriginalSources : data.excludedSourcesMlPlag,
    }

    this.similarityAnalysis = {
      originalSources: data.originalSources,
      translatedSources: data.translatedSources,
      submission: {
        originalPercentage: data.submission.originalPercentage,
        translatedPercentage: data.submission.translatedPercentage,
        originalLanguage: data.submission.originalLanguage,
        translatedLanguage: data.submission.translatedLanguage,
        originalPercentageWithoutQuotes: data.submission.originalPercentageWithoutQuotes,
        translatedPercentageWithoutQuotes: data.submission.translatedPercentageWithoutQuotes,
        translatedPercentages: data.submission.translatedPercentages
      }
    }

    this.aiAnalysis = {
      aiPercentage: data.submission.aiPercentage,
      checkAI: data.submission.aiDetection,
      originalSources: data.originalSources,
    }

    this.bannerDetails = {
      title: data.submission.title,
      original_language: data.submission.originalLanguage,
      translated_language: data.submission.translatedLanguage,
      ai_authorship_analysis: data.submission.aiDetection,
      file_size: data.submission.size,
      word_count: data.submission.wordCount,
      page_count: data.originalNavigationArray.length,
      documentId: data.submission.id
    }

    if (data.submission.title) {
      this.changeWebsiteTitle(data.submission.title)
    }

  }

  toggleIsOnAnalysis(): void {
    this.isOnAnalysis = !this.isOnAnalysis;
    this.fileUrl = this.tempPdfSrc;
  }

  isOnAnalysisChange(analysis: boolean) {
    this.isOnAnalysis = analysis;
    this.isOnAi = false;
    this.isOnManipulation = false;
    this.isOnCohort = false;

    if (!this.isOnAnalysis) {
      this.fileUrl = this.pdfImagesSrc;
      // When leaving analysis view, restore navigation with all content types
      this.navigationDetails = this.initialNavigationData.originalNavigationArray;
      this.updateNavigationArray();
    } else {
      this.fileUrl = this.tempPdfSrc;
    }
  }

  isOnAiChange(ai: boolean) {
    this.isOnAi = ai;
    this.isOnAnalysis = false;
    this.isOnManipulation = false;
    this.isOnCohort = false;

    if (ai) {
      this.navigationDetails = this.navigationArrayAI;
      this.fileUrl = this.tempPdfSrc;
    } else {
      // When leaving AI view, restore navigation with all content types
      this.navigationDetails = this.initialNavigationData.originalNavigationArray;
      this.updateNavigationArray();
      this.fileUrl = this.pdfImagesSrc;

      // Ensure Project Synapse is disabled when leaving AI view
      if (this.stylometricState.getProjectSynapseActive()) {
        this.stylometricState.toggleProjectSynapseActive(false);
      }
    }
  }

  isOnManipulationChange(manipulation: boolean) {
    this.isOnManipulation = manipulation;
    this.isOnAi = false;
    this.isOnAnalysis = false;

    if (manipulation) {
      this.fileUrl = this.tempPdfSrc;
    } else {
      this.fileUrl = this.pdfImagesSrc;
      // When leaving manipulation view, restore navigation with all content types
      this.navigationDetails = this.initialNavigationData.originalNavigationArray;
      this.updateNavigationArray();
    }
  }

  onManipulationsCalculated(manipulations: any) {
    if (this.isOnManipulation) {
      this.navigationDetails = manipulations;
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy(): void {
    this.currentPageSubscription.forEach((sub) => {
      sub.unsubscribe()
    })

    this.destroy$.next();
    this.destroy$.complete();
  }


  changeView(view: string, languageType?: string) {
    // Store the current Project Synapse state before making any changes
    const wasProjectSynapseActive = this.stylometricState.getProjectSynapseActive();

    // Only disable Project Synapse when switching to a view that should explicitly disable it,
    // not when switching between stylometric and classic or when switching to AI view
    if (view !== 'ai' && view !== 'stylometrics') {
      // Only toggle if currently active
      if (wasProjectSynapseActive) {
        this.stylometricState.forceProjectSynapseState(false);
      }
    }

    this.reportService.filterSources(0)
    this.filterSources(0)
    this.reportService.sentenceInformationSubject.next(null)

    // Preserve the current report type (classic or stylometric) when switching views
    const currentReportType = this.reportType;

    // Only switch to classic if we're not in stylometric AI mode and certain views
    if (view !== 'ai' || (view === 'ai' && this.reportType !== 'stylometric')) {
      // Only switch to classic report type for manipulation view or when explicitly requested
      // Otherwise, preserve the current report type (classic or stylometric)
      if (view === 'manipulation') {
        // Preserve Project Synapse state when changing view types
        this.stylometricState.setReportType('classic');

        // Restore Project Synapse state if it was active
        if (wasProjectSynapseActive) {
          // Use setTimeout to ensure this happens after other state changes
          setTimeout(() => {
            this.stylometricState.forceProjectSynapseState(true);
          }, 0);
        }
      } else {
        // For other views, maintain the current report type
        // This ensures stylometric view stays active if it was already active
      }
    }

    // Special handling for AI view to show the first available analysis
    if (view === 'ai') {
      // Clear sentence information to prevent analysis highlights from showing
      this.reportService.sentenceInformationSubject.next(null);

      // Reset to page 1
      this.documentDataService.setCurrentPage(1);

      // Force disable Project Synapse if it's not supposed to be active
      if (!wasProjectSynapseActive) {
        this.stylometricState.forceProjectSynapseState(false);
      }

      // Clear any existing analysis type first to prevent interference
      this.reportService.selectAnalysisTypeSubject.next('none');

      // Use the isOnAiChange method to properly set up AI view
      this.isOnAiChange(true);

      // Force AI bar initialization by directly setting which analysis should be active
      setTimeout(() => {
        if (wasProjectSynapseActive) {
          // If Project Synapse was active, restore it
          this.stylometricState.forceProjectSynapseState(true);
          this.reportService.selectAnalysisTypeSubject.next('projectSynapse');
        } else {
          // Force AI analysis to be the default if only simpleAI is enabled
          if (this.simpleAIEnable && !this.stylometricsEnable && !this.projectSynapseEnable && !this.metadataEnable) {
            this.reportService.selectAnalysisTypeSubject.next('ai');
          } else if (this.stylometricsEnable) {
            this.reportService.selectAnalysisTypeSubject.next('stylometrics');
          } else if (this.projectSynapseEnable && this.projectSynapse && this.projectSynapse.length > 0) {
            this.stylometricState.forceProjectSynapseState(true);
            this.reportService.selectAnalysisTypeSubject.next('projectSynapse');
          } else if (this.metadata && this.metadataEnable) {
            this.reportService.selectAnalysisTypeSubject.next('metadata');
          } else {
            this.reportService.selectAnalysisTypeSubject.next('ai');
          }
        }
      }, 50);

      // Let the AI bar component handle which analysis to show first
      // It will check for stylometrics, project synapse, metadata, or AI in that order
    } else if (view == 'dashboard' || view == 'isOnCohort') {
      this.fileUrl = view == 'isOnCohort' ? this.submissionDetails.fileUrl : this.pdfImagesSrc;
      this.reportService.selectAnalysisTypeSubject.next(view == 'dashboard' ? 'none' : view);
      this.isOnAnalysis = false;
      this.isOnAi = false;
      this.isOnManipulation = false;
      this.isOnCohort = view == 'isOnCohort';
      this.reportService.selectLanguageSubject.next({
        language: this.similarityAnalysis.submission.originalLanguage,
        type: 'Original'
      })
      this.documentDataService.setCurrentPage(1)
      this.stylometricState.setReportType('classic');

      // Clear navigation details when in cohort view to prevent dots from showing
      if (view == 'isOnCohort') {
        this.navigationDetails = [];
      } else if (view == 'dashboard') {
        // Restore navigation details for dashboard view to show all content types
        this.navigationDetails = this.initialNavigationData.originalNavigationArray;
        this.updateNavigationArray();
      }
    } else if (view == 'original_lang' || view == 'translated_lang') {
      // Preserve the current report type (classic or stylometric)
      this.stylometricState.setReportType(currentReportType);

      this.reportService.selectAnalysisTypeSubject.next('analysis');
      this.isOnAnalysis = true;
      this.isOnAi = false;
      this.isOnManipulation = false;
      this.isOnCohort = false;
      this.fileUrl = this.tempPdfSrc
      this.updateNavigationArray()
      this.stylometricState.setReportType('classic');
      this.documentDataService.setCurrentPage(1)
      if (languageType) {
        let translatedLang = '';
        if (this.similarityAnalysis.submission?.translatedLanguage?.split('').includes('[')) {
          // translatedLang = JSON.parse(this.similarityAnalysis.submission.translatedLanguage)[0]
          this.reportService.selectLanguageSubject.next({
            language: languageType === 'Original' ? this.getLanguageName(this.similarityAnalysis.submission.originalLanguage) : 'multiple_languages',
            type: languageType
          })
        } else {
          translatedLang = this.similarityAnalysis.submission.translatedLanguage
          this.reportService.selectLanguageSubject.next({
            language: languageType === 'Original' ? this.getLanguageName(this.similarityAnalysis.submission.originalLanguage) : this.getLanguageName(translatedLang),
            type: languageType
          })
        }
      }
    } else if (view == 'manipulation') {
      this.reportService.selectAnalysisTypeSubject.next('manipulation')
      this.isOnAnalysis = false;
      this.isOnAi = false;
      this.isOnCohort = false;
      this.isOnManipulation = true;
      this.fileUrl = this.tempPdfSrc
      // Ensure we're in classic mode for manipulations
      this.stylometricState.setReportType('classic');
      this.documentDataService.setCurrentPage(1)
    }
  }

  changeWebsiteTitle(title: string) {
    // First format and beatify the title, capitalize the first letter of each word
    const formattedTitle = title.replace(/\b\w/g, char => char.toUpperCase());
    this.titleService.setTitle(`Similarity Report for '${formattedTitle.trim()}' | Inspera Originality`)
  }

  transformData(data: any) {
    const { sentenceDetails, manipulations, submission, imagesDetection } = data;
    this.summaryDetails = sentenceDetails
      .filter((sentence: any) => {

        // Check if sentence has primary source, primary translated source, AI text, or any manipulations
        const hasPrimarySource = !!sentence?.primarySource;

        let hasPrimaryTranslatedSources;
        if (sentence?.translatedFindings) {
          hasPrimaryTranslatedSources = Object.keys(sentence?.translatedFindings || {}).some((lang: any) => {
            return !!sentence?.translatedFindings[lang]?.primarySource;
          });
        }
        else {
          hasPrimaryTranslatedSources = !!sentence?.primaryTranslatedSource;
        }
        const hasAiText = !!sentence?.aiText?.aiText;
        const hasManipulations = !!manipulations && (
          manipulations?.replacedCharacters?.some((item: any) => sentence?.replacedCharacters?.includes(item.character)) ||
          manipulations?.excludedReplacedCharacters?.some((item: any) => sentence?.replacedCharacters?.includes(item.character)) ||
          !!sentence?.characters?.length
        );

        return hasPrimarySource || hasPrimaryTranslatedSources || hasAiText || hasManipulations;
      })
      .map((sentence: any) => {
        const replacedCharacters = sentence?.replacedCharacters || [];
        const includedCharacters = manipulations?.replacedCharacters.filter((item: any) => {
          return replacedCharacters.includes(item.character);
        });

        const excludedReplacedCharacters = manipulations?.excludedReplacedCharacters.filter((item: any) => {
          return replacedCharacters.includes(item.character);
        });

        const characters = sentence?.characters || [];
        const manipulationsData = [
          {
            includedCharacters,
            excludedReplacedCharacters
          },
          {
            characters,
            isExcluded: sentence?.whitecharactersExcluded || false
          }
        ];

        let translated;
        let isTranslated;

        if (sentence?.translatedFindings) {
          translated = Object.keys(sentence?.translatedFindings).map((lang) => {
            const finding = sentence?.translatedFindings[lang];
            const allTranslatedPercentages = submission.translatedPercentages;


            return {
              lang,
              percentage: allTranslatedPercentages !== undefined ? (allTranslatedPercentages[lang]?.percentageWithoutQuotes ? allTranslatedPercentages[lang]?.percentageWithoutQuotes : allTranslatedPercentages[lang]?.percentage) : finding?.percentage,
              sentence: finding?.primarySource?.sourceSentence,
              source: finding?.primarySource,
              isExcluded: finding?.isTranslationExcluded,
              comment: finding?.translateComment,
              secondarySources: finding?.secondarySources,
              text: sentence?.translatedFindings[lang].translatedText,
              sourceHistory: sentence?.translatedFindings[lang]?.sourceHistory
            };
          });
          isTranslated = translated.some((item: any) => item.source);
        } else {
          const primaryTranslatedSource = sentence?.primaryTranslatedSource;

          // Filter out secondary sources that are in excludedSources

          translated = sentence?.translatedText
            ?
            [{
              lang: submission?.translatedLanguage,
              percentage: primaryTranslatedSource?.percentage,
              sentence: primaryTranslatedSource?.sourceSentence,
              source: primaryTranslatedSource,
              isExcluded: sentence?.isTranslationExcluded,
              comment: sentence?.translateComment,
              secondarySources: sentence?.secondarySources,
              text: sentence?.translatedText,
              sourceHistory: sentence?.sourceHistory
            }]
            :
            [];
          isTranslated = !!sentence?.translatedText;
        }

        const isManipulated = {
          isManipulated: (includedCharacters?.length > 0) || (characters?.length > 0),
          isCharReplacement: includedCharacters?.length > 0,
          isHiddenText: characters?.length > 0
        };

        // Filter out secondary sources that are in excludedSources
        return {
          submissionId: submission.id,
          text: sentence?.text,
          sentence: sentence?.primarySource?.sourceSentence,
          source: sentence?.primarySource,
          comment: sentence?.comment,
          id: sentence?.id,
          isOriginal: !!(sentence?.sourceSentence || sentence?.primarySource),
          isTranslated: isTranslated,
          isManipulated,
          isExcluded: sentence?.isExcluded,
          isAi: sentence?.aiText?.aiText,
          isCitation: sentence.isCitation,
          similarity: sentence?.primarySource?.percentage,
          page: sentence?.page,
          secondarySources: sentence?.secondarySources,
          manipulations: manipulationsData,
          translated,
          sourceHistory: sentence?.sourceHistory
        };
      });

    this.cdr.detectChanges();
  }

  // Create a function without parameters that calls transformData and call it getTransformData
  getTransformData() {
    this.getS3Json(this.submissionDetails.presignedUrlJson);
  }

  getLanguageName(languageCode: string): string {
    const language = this.languages.find((lang) => lang.value === languageCode);
    return language ? language.text : 'Unknown Language';
  }

  checkIfFileExists(url: string): Promise<boolean> {
    return this.http.get(url, { responseType: 'blob', observe: 'response' }).toPromise()
      .then(response => {
        return response.status === 200;
      })
      .catch(error => {
        if (error.status === 404 || error.status === 403) {
          return false;
        }
        return false;
      });
  }

  private getMetadata(presignedUrl: string): void {
    if (!presignedUrl) {
      this.metadata = null;
      return;
    }

    this.reportService.getS3Json(presignedUrl).subscribe(
      (metadata: any) => {
        if (metadata && metadata[0]) {
          this.metadata = metadata[0];
          this.cdr.detectChanges();
        } else {
          this.metadata = null;
        }
      },
      (error: any) => {
        console.error('Error fetching metadata:', error);
        this.metadata = null;
      }
    );
  }

  refreshMetadata(): void {
    if (this.metadataUrl) {
      this.getMetadata(this.metadataUrl);
    }
  }

  get hasAiOrMetadata(): boolean {
    return (this.aiAnalysis?.checkAI || !!this.metadata);
  }

  onSkipLinkClick(event: Event) {
    event.preventDefault(); // Prevent default navigation
    const target = document.getElementById('document-content');
    if (target) {
      target.focus(); // Set focus to the target element
    }
  }

  public switchReportType(type: 'classic' | 'stylometric') {
    // Store current state
    this.reportType = type;
    const isProjectSynapseActive = this.stylometricState.getProjectSynapseActive();

    // Update the report type in the service
    this.stylometricState.setReportType(type);

    // Restore Project Synapse state if it was active
    if (isProjectSynapseActive) {
      // Use setTimeout to ensure this happens after other state changes
      setTimeout(() => {
        this.stylometricState.forceProjectSynapseState(true);
        // Also ensure the analysis type is set to projectSynapse
        this.reportService.selectAnalysisTypeSubject.next('projectSynapse');
      }, 0);
    }
  }

  private formatStylometricData(data: any) {
    if (!data) return null;

    // Check if each category exists before processing
    return {
      lexical: data?.lexical ? Object.entries(data.lexical).map(([name, value]) => ({
        name,
        value: Number(value)
      })) : [],
      syntactic: data?.syntactic ? Object.entries(data.syntactic).map(([name, value]) => ({
        name,
        value: Number(value)
      })) : [],
      structural: data?.structural ? Object.entries(data.structural).map(([name, value]) => ({
        name,
        value: Number(value)
      })) : [],
      readability: data?.readability ? Object.entries(data.readability).map(([name, value]) => ({
        name,
        value: Number(value)
      })) : []
    };
  }

  private calculateAverageMetrics(submissions: any[]) {
    if (!submissions.length) return null;

    const categories = ['lexical', 'syntactic', 'structural', 'readability'];
    const result: any = {};

    categories.forEach(category => {
      // Skip if no submissions have data for this category
      if (!submissions.some(sub => sub.stylometricsData && sub.stylometricsData[category])) {
        result[category] = [];
        return;
      }

      // Find the first submission that has this category to get metrics names
      const firstWithCategory = submissions.find(sub =>
        sub.stylometricsData && sub.stylometricsData[category]);

      if (!firstWithCategory) {
        result[category] = [];
        return;
      }

      const metrics = Object.keys(firstWithCategory.stylometricsData[category]);

      result[category] = metrics.map(metricName => {
        const values = submissions
          .filter(sub => sub.stylometricsData &&
            sub.stylometricsData[category] &&
            sub.stylometricsData[category][metricName] !== undefined)
          .map(sub => Number(sub.stylometricsData[category][metricName]));

        const average = values.length ?
          values.reduce((a, b) => a + b, 0) / values.length :
          0;

        return {
          name: metricName,
          value: average
        };
      });
    });

    return result;
  }

  toggleSideBar() {
    this.sideBarCollapsed = !this.sideBarCollapsed;
  }

  get getCurrentModel(): string {
    this.stylometricState.selectedAIModel$.subscribe((model: any) => {
      console.log(model, 'model in report component');

      const modelNames = {
        'gpt-3': 'OpenAI\'s GPT-3',
        'gpt-4': 'OpenAI\'s GPT-4',
        'gpt-4o': 'OpenAI\'s GPT-4o',
        'gpt-4o-mini': 'OpenAI\'s GPT-4o-mini',
        'gpt-o1-preview': 'OpenAI\'s O1 Preview',
        'claude-3-5-sonnet': 'Anthropic\'s Claude 3.5 Sonnet',
        'claude-3-opus': 'Anthropic\'s Claude 3 Opus',
        'claude-3-haiku': 'Anthropic\'s Claude 3 Haiku',
        'claude-3-7-sonnet': 'Anthropic\'s Claude 3.7 Sonnet',
        'claude-3-7-sonnet-thinking': 'Anthropic\'s Claude 3.7 Sonnet Reasoning Model',
      }
      if (model) {
        this.currentModel = modelNames[model.value] || model.value;
      }
    });

    return this.currentModel;
  }

  get isProjectSynapseActive(): boolean {
    return this.stylometricState.getProjectSynapseActive();
  }

  shouldShowStylometricsButton(): boolean {
    if (!this.isProjectSynapseActive) {
      return true;
    }

    const currentModel = this.stylometricState.getCurrentAIModel();
    if (currentModel && currentModel.comparisonData) {
      const aiPercentage = currentModel.comparisonData.ai_percentage;
      return aiPercentage >= 30;
    }

    return false;
  }

}
